import { render } from "./PromoBox.vue?vue&type=template&id=0e981210"
import script from "./PromoBox.vue?vue&type=script&lang=js"
export * from "./PromoBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__